import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initializeDialogAccessibility } from './lib/dialogAccessibility';
import { initializeFocusMethodTracking } from './lib/focusMethod';
import { initializeScrollableRegionAccessibility } from './lib/scrollableRegions';

// Initialize comprehensive dialog accessibility system
// This addresses WCAG violations KDAP2-2935 and KDAP2-2936
initializeDialogAccessibility();

initializeFocusMethodTracking();

initializeScrollableRegionAccessibility();

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);

reportWebVitals();
